const de = {
    sale: 'Verkäufe',
    hello: 'Hallo World!',
    save: 'Speichern',
    reset: 'Zurücksetzen',
    delete: 'Löschen',
    add_user: 'Benutzer hinzufügen',
    edit_user: 'Benutzer bearbeiten',
    go_back: 'zurück zur Übersicht',
    show_ordered_goods: 'Bestellte Ware',
    show_stock_items: 'Lagerware',
    loading_error_alert: 'Es ist ein Fehler beim laden der Seite aufgetretten.',
    id: 'Id',
    name: 'Name',
    description: 'Beschreibung',
    define_columns: 'Spalten festlegen',
    search_columns: 'Spalte suchen',
    show_columns: 'Sichtbar',
    hidden_columns: 'Unsichtbar',
    product: 'Produkt',
    category: 'Kategorie',
    marker_category: 'Markierte Kategorien',
    new_category: 'Neues Kategorie',
    property: 'Attribute',
    marker_property: 'Markierte Attribute',
    new_property: 'Neue Attribute',
    propset: 'Attributset',
    marker_propset: 'Markierte Attributset',
    new_propset: 'Neue Attributset',
    customer: 'Kunde',
    marker_customer: 'Markierte Kunde',
    new_customer: 'Neuer Kunde',
    group: 'Kundengruppe',
    marker_group: 'Markierte Kundengruppe',
    new_group: 'Neuer Kundengruppe',
    order: 'Bestellung',
    marker_order: 'Markierte Bestellung',
    new_order: 'Neue Bestellung',
    content: 'Inhalte',
    marker_content: 'Markierte Inhalte',
    new_content: 'Neuen Inhalt',
    page: 'Seite',
    marker_page: 'Markierte Seite',
    new_page: 'Neue Seite',
    delivery: 'Lieferung',
    marker_delivery: 'Markierte Lieferung',
    new_delivery: 'Neue Lieferung',
    supplier: 'Lieferant',
    marker_supplier: 'Markierte Lieferant',
    new_supplier: 'Neuer Lieferant',
    goods_receipt: 'Wareneingang',
    new_goods_receipt: 'Neuer Wareneingang',
    marker_goods_receipt: 'Markierte Waren',
    finish_goods_receipt: 'Wareneingang Abschließen',
    commission_box: 'Kommission',
    marker_commission_box: 'Markierte Kommission',
    new_commission_box: 'Neue Kommission',
    claim: 'Reklamation',
    marker_claim: 'Markierte Reklamation',
    new_claim: 'Neue Reklamation',
    purchase: 'Kauf',

    Active: 'Aktiv',
    Inactive: 'Inaktiv',

    Name: 'Name',
    Description: 'Beschreibung',
    Status: 'Status',
    Enabled: 'Aktiv',
    enabled: 'aktiv',
    Disabled: 'Inaktiv',
    disabled: 'inaktiv',

    'Show original text': 'Originaltext anzeigen',

    'Gross price': 'Brutto-Preis',
    'Net price': 'Netto-Preis',
    'Tax rate': 'Steuersatz',
    Type: 'Art',
    'Customer group': 'Kundengruppe',
    'Special Prices': 'Sonderpreise',
    'Add Price': 'Preis hinzufügen',

    'Something went wrong!': 'Etwas ist schief gelaufen!',
    'An error occurred!': 'Es ist ein Fehler aufgetreten!',
    'URL Not Valid': 'URL ungültig',

    'yyyy-MM-dd': 'dd.MM.yyyy',
    'yyyy-MM': 'MMMM yyyy',
    'yyyy Week WW': '"Woche" WW, yyyy',

    'YYYY-MM-DD': 'DD.MM.YYYY',
    'YYYY-MM': 'MMMM YYYY',
    'YYYY \\W\\e\\e\\k WW': '\\W\\o\\c\\h\\e WW, YYYY',

    'Publish from / to': 'Veröffentlichen ab / bis',
    'Publish start': 'Veröffentlichen ab',
    'Publish end': 'Veröffentlichen bis',
    Publish: 'Veröffentlichen',

    'Form is not valid!': 'Formular ist ungültig!',
    'Correct your input and submit again.': 'Korrigieren Sie die Eingaben.',
    Save: 'Speichern',
    'Save and close': 'Speichern und schließen',
    'Save and new': 'Speichern und neu',
    "Don't keep asking": 'Nicht mehr fragen',
    Dismiss: 'Abbrechen',
    Cancel: 'Abbrechen',
    Delete: 'Löschen',

    edit: 'bearbeiten',
    done: 'fertig',

    Visible: 'Sichtbar',
    Hidden: 'Verborgen',
    'Hidden in menu': 'Im Menü verborgen',

    'Under Construction': 'In Entwicklung',
    'Come back another time': 'Schau doch später nochmal vorbei',

    'You are not authorized': 'Du bist nicht berechtigt',
    'You are not allowed to be here': 'Du darfst nicht hier sein',
    'You are not allowed to see this': 'Du darfst das nicht sehen',
    'Not Allowed': 'Nicht erlaubt',
    Unauthorized: 'Nicht autorisiert',

    'Bulk action processed successfully!': 'Massenaktion erfolgreich verarbeitet!',
    'Bulk action could not be processed.': 'Massenaktion konnte nicht verarbeitet werden.',
    'Bulk action will be processed asynchronously': 'Massenaktion wird asynchron verarbeitet',

    'Status log could not be hidden.': 'Statusprotokoll konnte nicht ausgeblendet werden.',
    'You will be notified once the action is completed':
        'Sie werden benachrichtigt, sobald die Aktion abgeschlossen ist',

    'Download CSV': 'CSV herunterladen',
    'Download PDF': 'PDF herunterladen',
    'Download file': 'Datei herunterladen',

    '{job} completed': '{job} abgeschlossen',
    '{job} failed': '{job} fehlgeschlagen',

    'Stock was successfully exported': 'Warenbestand wurde erfolgreich exportiert',
    'Stock export has failed': 'Warenbestand-Export ist fehlgeschlagen',

    'Sales were successfully exported': 'Umsatz wurde erfolgreich exportiert',
    'Sales export has failed': 'Umsatz-Export ist fehlgeschlagen',

    'This is not a valid path.': 'Dies ist kein gültiger Pfad.',

    pagination: {
        nothingFound: 'Es konnten keine Enträge gefunden werden',
    },

    upload: {
        drop: {
            singular: '<h3>Datei hierher bewegen</h3> oder <em>hier klicken</em>',
            plural: '<h3>Dateien hierher bewegen</h3> oder <em>hier klicken</em>',
        },
        notUploaded: 'Datei konnte nicht hochgeladen werden!',
        sizeExceeded: 'Dateigröße überschritten!',
        max: 'Max. {size}',
        validation: 'Zulässig sind {filetypes} Dateien, die eine Größe von {size} nicht überschreiten',
    },

    section: {
        add: {
            drop: '<span class="highlight">{section}</span> hier hinzufügen',
            click: 'Hier klicken, um <span class="highlight">{section}</span> hinzuzufügen',
            hint: 'Klicken zum Einfügen oder per Drag & Drop positionieren',
        },
        paste: {
            click: 'Hier klicken, um <span class="highlight">{section}</span> einzufügen',
        },
        search: {
            no_results: 'Keine Ergebnisse für „{query}"',
        },
    },
    pdf: {
        stockReportCreated: 'PDF Artikelbestand wurde erfolgreich erstellt.',
        inventoryProtocolCreated: 'PDF Inventur-Protokoll wurde erfolgreich erstellt.',
    },
    'Shipping method name already taken.': 'Regelname ist bereits vorhanden. Bitte anderen Namen wählen.',
    'Mapping already exists!': 'Zuordnung ist bereits vorhanden!',

    // ── BannerEditor – Hilfe-Dialog ────────────────────────────────────────
    'Help & Guide': 'Hilfe & Anleitung',
    'Start guided tour': 'Geführte Tour starten',
    Close: 'Schließen',

    // Schritt-für-Schritt
    'Step-by-step guide': 'Schritt-für-Schritt-Anleitung',
    'Create slide': 'Folie erstellen',
    'Click "Slide" in the top left to add a new empty slide. An existing slide can be copied via the duplicate icon or reordered by drag & drop in the left sidebar.':
        'Klicke oben links auf „Folie", um eine neue leere Folie hinzuzufügen. Eine bestehende Folie lässt sich über das Duplizieren-Symbol kopieren oder per Drag & Drop in der linken Leiste umsortieren.',
    'Set up background': 'Hintergrund festlegen',
    'Click "Background" at the bottom → choose image, video or color/gradient. Via "Background Options" you can set overlay color, blur, position, grayscale and sepia filters.':
        'Klicke unten auf „Hintergrund" → Bild, Video oder Farbe/Verlauf wählen. Unter „Hintergrundoptionen" lassen sich Überlagerungsfarbe, Blur, Position, Graustufen- und Sepia-Filter einstellen.',
    'Add elements': 'Elemente hinzufügen',
    'Click "+ Element" at the bottom → choose block type: Text, Shape, Button, Image or Video. The new block appears centered on the slide and is immediately selected. Elements can also be added via right-click on the canvas.':
        'Klicke unten auf „+ Element" → Block-Typ wählen: Text, Form, Button, Bild oder Video. Der neue Block erscheint zentriert auf der Folie und ist sofort ausgewählt. Elemente können auch per Rechtsklick auf die Arbeitsfläche hinzugefügt werden.',
    'Position & scale element': 'Element positionieren & skalieren',
    'Click a block and drag it to the desired position. Resize using the white corner handles. Arrow keys move by 0.5% (with Shift: 2%). Enable guides (toolbar) – elements snap automatically to grid and center lines.':
        'Block anklicken und an die gewünschte Position ziehen. Größe über die weißen Eck-Handles ändern. Pfeiltasten verschieben um 0,5 % (mit Shift: 2 %). Hilfslinien aktivieren (Toolbar) – Elemente rasten automatisch an Raster- und Mittellinien ein.',
    'Customize appearance': 'Aussehen anpassen',
    'Select a block → the block toolbar appears automatically at the top. Depending on type: font, color, gradient, border, shadow, corners, opacity, rotation etc. Double-click on text or button blocks to edit the text directly.':
        'Block auswählen → die Block-Toolbar erscheint automatisch oben. Je nach Typ: Schrift, Farbe, Verlauf, Rahmen, Schatten, Ecken, Deckkraft, Rotation usw. Doppelklick auf Text- oder Button-Blöcke zum direkten Bearbeiten des Textes.',
    'Add animation (optional)': 'Animation hinzufügen (optional)',
    'Right-click on an element → Animation → select effect. Set delay and duration in the same menu or adjust by dragging in the "Animation Timeline" (button at the bottom).':
        'Rechtsklick auf ein Element → Animation → Effekt wählen. Verzögerung und Dauer im selben Menü einstellen oder per Ziehen in der „Animations-Timeline" (Schaltfläche unten) anpassen.',
    'Assign link (optional)': 'Link zuweisen (optional)',
    'Right-click on an element → Link. Available types: Internal, External, Email, Phone and Media Library file. Button blocks also have a link icon directly in the toolbar.':
        'Rechtsklick auf ein Element → Link. Verfügbare Typen: Intern, Extern, E-Mail, Telefon und Mediathek-Datei. Button-Blöcke haben zudem ein Link-Symbol direkt in der Toolbar.',
    Save: 'Speichern',
    'Click "Save" outside the editor to apply all changes. Undo / Redo at any time via Ctrl+Z / Ctrl+Y or the toolbar buttons.':
        'Klicke außerhalb des Editors auf „Speichern", um alle Änderungen zu übernehmen. Rückgängig / Wiederholen jederzeit über Strg+Z / Strg+Y oder die Toolbar-Schaltflächen.',

    // Folien verwalten
    'Manage slides': 'Folien verwalten',
    'Add slide': 'Folie hinzufügen',
    'Insert a new empty slide at the end. Each slide has its own background, elements and settings.':
        'Am Ende eine neue leere Folie einfügen. Jede Folie hat eigenen Hintergrund, Elemente und Einstellungen.',
    'Duplicate slide': 'Folie duplizieren',
    'Copy the active slide with all blocks, animations and settings – ideal for similar slides.':
        'Die aktive Folie mit allen Blöcken, Animationen und Einstellungen kopieren – ideal für ähnliche Folien.',
    'Delete slide': 'Folie löschen',
    'Remove the active slide. At least one slide must always remain.':
        'Die aktive Folie entfernen. Es muss immer mindestens eine Folie vorhanden bleiben.',
    'Change order': 'Reihenfolge ändern',
    'Reorder slides in the left sidebar via drag & drop.': 'Folien in der linken Leiste per Drag & Drop umsortieren.',

    // Folienhintergrund
    'Slide background': 'Folienhintergrund',
    'Background image': 'Hintergrundbild',
    'Choose an image from the media library. The position (Top / Center / Bottom) can be set under "Background Options".':
        'Ein Bild aus der Mediathek wählen. Die Position (Oben / Mitte / Unten) lässt sich unter „Hintergrundoptionen" einstellen.',
    'Background video': 'Hintergrundvideo',
    'Choose a video from the media library. The video plays automatically muted in a loop.':
        'Ein Video aus der Mediathek wählen. Das Video spielt automatisch stumm in Endlosschleife.',
    'Background color / Gradient': 'Hintergrundfarbe / Verlauf',
    'Define a solid background or a linear/radial gradient with two colors and adjustable angle.':
        'Einfarbigen Hintergrund oder einen linearen/radialen Verlauf mit zwei Farben und einstellbarem Winkel festlegen.',
    'Background options': 'Hintergrundoptionen',
    'Color overlay (tint), blur, image position, grayscale filter and sepia filter. Active options are shown counted in parentheses.':
        'Farbüberlagerung (Tönung), Blur, Bildposition, Graustufen- und Sepia-Filter. Aktive Optionen werden mit Anzahl in Klammern angezeigt.',

    // Block-Typen
    'Block types': 'Block-Typen',
    'Text block': 'Textblock',
    'Multi-line body text. Double-click to edit. Supports Bold, Italic, Underline, Strikethrough, font family, font size, color, alignment, line-height and letter-spacing, background color/gradient, border (width, style, color, corners) and shadow.':
        'Mehrzeiliger Fließtext. Doppelklick zum Bearbeiten. Unterstützt Fett, Kursiv, Unterstrichen, Durchgestrichen, Schriftfamilie, Schriftgröße, Farbe, Ausrichtung, Zeilenhöhe und Zeichenabstand, Hintergrundfarbe/Verlauf, Rahmen (Breite, Stil, Farbe, Ecken) und Schatten.',
    'Shape block': 'Form-Block',
    'Geometric shapes: Rectangle, Circle, Triangle, Diamond, Star, Hexagon, Arrow. Solid fill or linear/radial gradient. Border (width, style, color) only for Rectangle and Circle. Rounded corners only for Rectangle. Opacity and shadow for all shapes.':
        'Geometrische Formen: Rechteck, Kreis, Dreieck, Raute, Stern, Sechseck, Pfeil. Einfarbige Füllung oder linearer/radialer Verlauf. Rahmen (Breite, Stil, Farbe) nur für Rechteck und Kreis. Abgerundete Ecken nur für Rechteck. Deckkraft und Schatten für alle Formen.',
    'Button block': 'Button-Block',
    'Clickable button with an assigned link. Double-click to edit text. Background solid or as gradient (linear/radial). Font: size, color, family, Bold, Italic, Underline, Strikethrough. Border (width, style, color), rounded corners and shadow also configurable.':
        'Klickbarer Button mit zugewiesenem Link. Doppelklick zum Bearbeiten des Textes. Hintergrund einfarbig oder als Verlauf (linear/radial). Schrift: Größe, Farbe, Familie, Fett, Kursiv, Unterstrichen, Durchgestrichen. Rahmen (Breite, Stil, Farbe), abgerundete Ecken und Schatten ebenfalls einstellbar.',
    'Image block': 'Bild-Block',
    'Freely position and scale an image from the media library. Crop tool available directly in the toolbar. Image fit: Contain / Cover / Stretch (right-click → Image size). Filters: B&W, Sepia, Duotone (preset or custom 2 colors). Background color, border (width, style, individual sides, color, corner radius) and shadow are also configurable.':
        'Ein Bild aus der Mediathek frei positionieren und skalieren. Zuschnitt-Werkzeug direkt in der Toolbar verfügbar. Bildanpassung: Enthalten / Abdecken / Strecken (Rechtsklick → Bildgröße). Filter: S/W, Sepia, Duotone (Voreinstellung oder 2 benutzerdefinierte Farben). Hintergrundfarbe, Rahmen (Breite, Stil, einzelne Seiten, Farbe, Eckenradius) und Schatten ebenfalls einstellbar.',
    'Video block': 'Video-Block',
    'Embed YouTube or Vimeo via URL, or use a video from the media library (MP4/WebM). Controls: Autoplay, Mute, Loop, Show controls, Round display, Portrait/Landscape orientation (for YouTube/Vimeo). Filters: B&W, Sepia, Duotone. Border, rounded corners, shadow and opacity adjustable.':
        'YouTube oder Vimeo per URL einbetten oder Video aus der Mediathek verwenden (MP4/WebM). Steuerung: Autoplay, Stumm, Schleife, Player-Bedienelemente anzeigen, Rund darstellen, Hochformat/Querformat (für YouTube/Vimeo). Filter: S/W, Sepia, Duotone. Rahmen, abgerundete Ecken, Schatten und Deckkraft einstellbar.',

    // Position & Skalierung
    'Position & Scale': 'Position & Skalierung',
    Move: 'Verschieben',
    'Click and drag a block. Alternatively: arrow keys (0.5% per step), hold Shift (2% per step).':
        'Block anklicken und ziehen. Alternativ: Pfeiltasten (0,5 % pro Schritt), Shift gedrückt halten (2 % pro Schritt).',
    Scale: 'Skalieren',
    'Drag the white corner handles. Width and height are stored as a percentage of the slide size and scale proportionally on every device.':
        'Die weißen Eck-Handles ziehen. Breite und Höhe werden als Prozentsatz der Foliengröße gespeichert und skalieren auf jedem Gerät proportional.',
    Rotation: 'Rotation',
    'Click the rotation button (circular arrow) in the block toolbar and enter the angle in degrees.':
        'Die Rotations-Schaltfläche (Kreispfeil) in der Block-Toolbar anklicken und den Winkel in Grad eingeben.',
    Guides: 'Hilfslinien',
    'Safety frame (8% margin), center lines (50%) and third lines (33 / 66%). Elements snap automatically to these lines when dragging.':
        'Sicherheitsrahmen (8 % Abstand), Mittellinien (50 %) und Drittellinien (33 / 66 %). Elemente rasten beim Ziehen automatisch an diesen Linien ein.',
    'Layer order': 'Ebenenreihenfolge',
    'Right-click on an element → "Bring forward" / "Send backward" to change the stacking order.':
        'Rechtsklick auf ein Element → „Nach vorne" / „Nach hinten" zum Ändern der Stapelreihenfolge.',
    'Unit vw': 'Einheit vw',
    'All size and position values are relative to the slider width (vw = 1% of the width). This means all elements scale proportionally on every device – no fixed pixel values needed.':
        'Alle Größen- und Positionswerte sind relativ zur Slider-Breite (vw = 1 % der Breite). Damit skalieren alle Elemente auf jedem Gerät proportional – keine fixen Pixel-Werte nötig.',
    'Multi-select': 'Mehrfachauswahl',
    'Hold Shift and click multiple blocks to select them simultaneously. A multi-selection bar appears at the top showing the count. All selected blocks can be deleted at once.':
        'Shift gedrückt halten und mehrere Blöcke anklicken, um sie gleichzeitig auszuwählen. Eine Mehrfachauswahl-Leiste erscheint oben mit der Anzahl. Alle ausgewählten Blöcke lassen sich auf einmal löschen.',
    'Align via right-click': 'Ausrichten per Rechtsklick',
    'Right-click on an element → Position → Align left / Center horizontally / Align right / Top / Center vertically / Bottom. Alternatively enter exact X and Y values (%) directly in the position sub-menu.':
        'Rechtsklick auf ein Element → Position → Links ausrichten / Horizontal zentrieren / Rechts ausrichten / Oben / Vertikal zentrieren / Unten. Alternativ exakte X- und Y-Werte (%) direkt im Positionsuntermenü eingeben.',

    // Text & Button Toolbar
    'Text & Button toolbar': 'Text- & Button-Toolbar',
    'Bold / Italic / Underline / Strikethrough': 'Fett / Kursiv / Unterstrichen / Durchgestrichen',
    'Formatting buttons directly in the block toolbar. For text blocks, the formatting applies to the entire block.':
        'Formatierungsschaltflächen direkt in der Block-Toolbar. Bei Textblöcken gilt die Formatierung für den gesamten Block.',
    'Font family & size': 'Schriftfamilie & -größe',
    'Choose a font from the dropdown. Enter font size in vw – adapts automatically to every screen size (e.g. 2 vw ≈ 38 px on Full HD).':
        'Schrift aus dem Dropdown wählen. Schriftgröße in vw eingeben – passt sich automatisch jeder Bildschirmgröße an (z. B. 2 vw ≈ 38 px bei Full HD).',
    'Line height & letter spacing': 'Zeilenhöhe & Zeichenabstand',
    'Set line-height and letter-spacing in the typography dropdown (Aa icon).':
        'Zeilenhöhe und Zeichenabstand im Typografie-Dropdown (Aa-Symbol) einstellen.',
    'Text alignment': 'Textausrichtung',
    'Left, center or right – for text blocks only.': 'Links, zentriert oder rechts – nur für Textblöcke.',
    'Text background': 'Texthintergrund',
    'Background color with adjustable opacity and optional padding. Border: width, style (Solid, Dashed, Dotted), color and corner radius.':
        'Hintergrundfarbe mit einstellbarer Deckkraft und optionalem Innenabstand. Rahmen: Breite, Stil (Durchgezogen, Gestrichelt, Gepunktet), Farbe und Eckenradius.',
    'Button background': 'Button-Hintergrund',
    'Solid or gradient (linear with angle or radial). Two colors freely selectable, CI colors are offered as quick selection.':
        'Einfarbig oder Verlauf (linear mit Winkel oder radial). Zwei Farben frei wählbar, CI-Farben werden als Schnellauswahl angeboten.',
    'Button border': 'Button-Rahmen',
    'Border width in px, style (Solid, Dashed, Dotted) and border color. CI colors are available as quick selection.':
        'Rahmenbreite in px, Stil (Durchgezogen, Gestrichelt, Gepunktet) und Rahmenfarbe. CI-Farben sind als Schnellauswahl verfügbar.',

    // Bild-Block Toolbar
    'Image block toolbar': 'Bild-Block-Toolbar',
    'Crop image': 'Bild zuschneiden',
    'Click "Crop image" in the toolbar to open the cropping dialog. After cropping, the cut section is saved as a separate image URL – the original is preserved.':
        'In der Toolbar auf „Bild zuschneiden" klicken, um den Zuschneiden-Dialog zu öffnen. Nach dem Zuschneiden wird der Ausschnitt als eigene Bild-URL gespeichert – das Original bleibt erhalten.',
    'Image fit (Contain / Cover / Stretch)': 'Bildanpassung (Enthalten / Abdecken / Strecken)',
    'Right-click on the image block → Image size → choose fit mode. Contain: image fully visible with letterboxing. Cover: fills the block, cropped. Stretch: distorted to fill.':
        'Rechtsklick auf den Bild-Block → Bildgröße → Anpassungsmodus wählen. Enthalten: Bild vollständig sichtbar mit Letterboxing. Abdecken: füllt den Block, wird beschnitten. Strecken: verzerrt zum Füllen.',
    'Opacity & Filter': 'Deckkraft & Filter',
    'Toolbar button "Opacity / Filter": set transparency (0–100 %). Filters: B&W (grayscale), Sepia or Duotone – choose from presets or define two custom colors for shadow and highlight tones.':
        'Toolbar-Schaltfläche „Deckkraft / Filter": Transparenz einstellen (0–100 %). Filter: S/W (Graustufen), Sepia oder Duotone – aus Voreinstellungen wählen oder zwei eigene Farben für Schatten- und Lichttöne definieren.',
    'Background / Border': 'Hintergrund / Rahmen',
    'Add a color frame behind the image. Border: width, style (Solid, Dashed, Dotted), color and individually toggleable sides (Top / Right / Bottom / Left). Rounded corners in px.':
        'Farbrahmen hinter dem Bild hinzufügen. Rahmen: Breite, Stil (Durchgezogen, Gestrichelt, Gepunktet), Farbe und einzeln schaltbare Seiten (Oben / Rechts / Unten / Links). Abgerundete Ecken in px.',
    'Shadow (image)': 'Schatten (Bild)',
    'Enable drop shadow; set blur radius and color (CI colors, standard palette or custom hex color).':
        'Schlagschatten aktivieren; Unschärferadius und Farbe einstellen (CI-Farben, Standard-Palette oder benutzerdefinierte Hex-Farbe).',

    // Video-Block Toolbar
    'Video block toolbar': 'Video-Block-Toolbar',
    'Video URL': 'Video-URL',
    'Paste a YouTube or Vimeo URL into the URL field – the video ID is detected automatically. Alternatively select a video from the media library (MP4, WebM).':
        'Eine YouTube- oder Vimeo-URL in das URL-Feld einfügen – die Video-ID wird automatisch erkannt. Alternativ ein Video aus der Mediathek auswählen (MP4, WebM).',
    'Playback controls': 'Wiedergabe-Steuerung',
    'Autoplay (requires Mute), Mute, Loop and Show player controls are each individually switchable via toolbar buttons.':
        'Autoplay (erfordert Stummschalten), Stumm, Schleife und Player-Bedienelemente anzeigen sind jeweils einzeln über Toolbar-Schaltflächen umschaltbar.',
    'Round display / Portrait': 'Runde Darstellung / Hochformat',
    'Round: shows the video clipped as a circle. Portrait / Landscape toggle (YouTube/Vimeo): switches between 9:16 and 16:9 aspect ratio in the block.':
        'Rund: zeigt das Video als Kreis zugeschnitten. Hochformat/Querformat-Umschalter (YouTube/Vimeo): wechselt zwischen 9:16 und 16:9 Seitenverhältnis im Block.',
    'Opacity & Filter (video)': 'Deckkraft & Filter (Video)',
    'Opacity slider plus color filters: B&W, Sepia or Duotone (preset or custom 2-color combination). Duotone maps the dark tones to color 1 and the light tones to color 2.':
        'Deckkraft-Schieberegler plus Farbfilter: S/W, Sepia oder Duotone (Voreinstellung oder benutzerdefinierte 2-Farben-Kombination). Duotone ordnet die dunklen Töne Farbe 1 und die hellen Töne Farbe 2 zu.',
    'Border & Corners (video)': 'Rahmen & Ecken (Video)',
    'Border width in px, style (Solid, Dashed, Dotted), selective sides, border color. Rounded corners in px (0 = sharp, 200 = fully rounded/circle).':
        'Rahmenbreite in px, Stil (Durchgezogen, Gestrichelt, Gepunktet), wählbare Seiten, Rahmenfarbe. Abgerundete Ecken in px (0 = scharf, 200 = vollständig abgerundet/Kreis).',
    'Shadow (video)': 'Schatten (Video)',
    'Drop shadow with adjustable blur radius and color.': 'Schlagschatten mit einstellbarem Unschärferadius und Farbe.',

    // Animationen
    Animations: 'Animationen',
    'Assign animation': 'Animation zuweisen',
    'Right-click on an element → Animation → select effect. 18 entrance effects available (Slide, Fade, Zoom, Bounce, Fly in, etc.).':
        'Rechtsklick auf ein Element → Animation → Effekt wählen. 18 Eingangseffekte verfügbar (Slide, Fade, Zoom, Bounce, Hereinfliegen usw.).',
    'Fly-in animations': 'Hereinfliegen-Animationen',
    '4 new effects: "Fly from top / bottom / left / right". The element starts completely outside the visible area and flies into its position – no fade, pure movement.':
        '4 neue Effekte: „Von oben / unten / links / rechts hereinfliegen". Das Element startet vollständig außerhalb des sichtbaren Bereichs und fliegt in seine Position – kein Fade, reine Bewegung.',
    'Delay & duration': 'Verzögerung & Dauer',
    'In the right-click menu under "Animation" or directly in the timeline (drag bar = delay, drag right edge = duration).':
        'Im Rechtsklick-Menü unter „Animation" oder direkt in der Timeline (Balken ziehen = Verzögerung, rechten Rand ziehen = Dauer).',
    'Easing (motion curve)': 'Easing (Bewegungskurve)',
    'Right-click → Animation → Type. 8 curves from "Ease" to "Elastic" selectable.':
        'Rechtsklick → Animation → Typ. 8 Kurven von „Ease" bis „Elastic" wählbar.',
    'Animation timeline': 'Animations-Timeline',
    'Show button at the bottom. Displays all blocks of the active slide in a timeline – change delay and duration by dragging.':
        'Anzeige-Schaltfläche unten. Zeigt alle Blöcke der aktiven Folie in einer Timeline – Verzögerung und Dauer per Ziehen ändern.',

    // Layout & Einstellungen
    'Layout & Settings': 'Layout & Einstellungen',
    'Banner height': 'Banner-Höhe',
    'Set the height in vw in the layout panel (toolbar) (10–100). The banner is then x% as tall as the screen is wide.':
        'Die Höhe in vw im Layout-Panel (Toolbar) einstellen (10–100). Der Banner ist dann x % so hoch wie der Bildschirm breit ist.',
    'Canvas layout': 'Canvas-Layout',
    '"Centered (in container)" = slider centered in the page width. "Full width" = slider across the full page width. "Full width (container)" = full width, but content limited to container.':
        '„Zentriert (im Container)" = Slider zentriert in der Seitenbreite. „Volle Breite" = Slider über die gesamte Seitenbreite. „Volle Breite (Container)" = volle Breite, aber Inhalt auf Container begrenzt.',
    'Outer area (container layout)': 'Außenbereich (Container-Layout)',
    'With "Centered" layout the side outer area can be left empty, colored or blurred (image blur).':
        'Bei „Zentriert"-Layout kann der seitliche Außenbereich leer gelassen, eingefärbt oder unscharf gestellt werden (Bild-Blur).',

    // Verlauf & Tastenkürzel
    'History & shortcuts': 'Verlauf & Tastenkürzel',
    'Undo / Redo': 'Rückgängig / Wiederholen',
    'Ctrl+Z / Ctrl+Y or the arrow buttons in the toolbar. The history covers all changes of the current session.':
        'Strg+Z / Strg+Y oder die Pfeil-Schaltflächen in der Toolbar. Der Verlauf umfasst alle Änderungen der aktuellen Sitzung.',
    'Right-click menu (element)': 'Rechtsklick-Menü (Element)',
    'Right-click on an element opens: Edit, Copy, Paste, Delete, Position (align + X/Y input), Layer (Bring to front / Send to back), Rotate (−90°/−10°/+10°/+90°, exact degree input, Reset), Animation, Link, Image size (for image blocks).':
        'Rechtsklick auf ein Element öffnet: Bearbeiten, Kopieren, Einfügen, Löschen, Position (Ausrichten + X/Y-Eingabe), Ebene (In den Vordergrund / In den Hintergrund), Drehen (−90°/−10°/+10°/+90°, exakte Gradeingabe, Zurücksetzen), Animation, Link, Bildgröße (für Bild-Blöcke).',
    'Right-click menu (canvas)': 'Rechtsklick-Menü (Arbeitsfläche)',
    'Right-click on the canvas background opens: Add element (all types including Video), Paste, Change/remove background image or video.':
        'Rechtsklick auf den Hintergrund der Arbeitsfläche öffnet: Element hinzufügen (alle Typen inkl. Video), Einfügen, Hintergrundbild oder -video wechseln/entfernen.',
    'Copy & Paste': 'Kopieren & Einfügen',
    'Right-click on an element → Copy. Then right-click anywhere → Paste to insert a duplicate. Works across slides within the same editor session.':
        'Rechtsklick auf ein Element → Kopieren. Dann Rechtsklick irgendwo → Einfügen, um ein Duplikat einzufügen. Funktioniert folienübergreifend innerhalb derselben Editor-Sitzung.',
    'Add link': 'Link hinzufügen',
    'Right-click → Link or link icon in the button toolbar. Link types: Internal (page), External (URL), Email, Phone, Media Library file.':
        'Rechtsklick → Link oder Link-Symbol in der Button-Toolbar. Link-Typen: Intern (Seite), Extern (URL), E-Mail, Telefon, Mediathek-Datei.',
    'Keyboard shortcuts': 'Tastenkürzel',
    'Del = delete selected element. Arrow keys = move element 0.5% per step (+ Shift = 2% per step). Ctrl+Z = Undo. Ctrl+Y = Redo.':
        'Entf = ausgewähltes Element löschen. Pfeiltasten = Element 0,5 % pro Schritt verschieben (+ Shift = 2 % pro Schritt). Strg+Z = Rückgängig. Strg+Y = Wiederholen.',
    'Guided tour': 'Geführte Tour',
    'Click "Start guided tour" at the bottom of this dialog to get a step-by-step interactive introduction to all key areas of the editor.':
        'Klicke unten in diesem Dialog auf „Geführte Tour starten", um eine schrittweise interaktive Einführung in alle wichtigen Bereiche des Editors zu erhalten.',

    // Platzhalter-Auswahl (quill/toolbar/placeholder). Der Schlüssel steht in den
    // Konfigurationen (signatureConfig, messagePresetConfig); übersetzt wird beim
    // Rendern, weil ein Quill-Modul kein $t hat.
    // KI-Texterstellung (quill/toolbar/textGeneration), ebenfalls ohne $t.
    'What should the AI write?': 'Was soll die KI schreiben?',
    'Create text': 'Text erstellen',
    'Creating text': 'Text wird erstellt',
    'Please describe what the AI should write.': 'Bitte beschreiben Sie, was die KI schreiben soll.',
    'The text could not be created.': 'Der Text konnte nicht erstellt werden.',
    'Knowledge base not available': 'Wissensdatenbank nicht erreichbar',
    'Please check the text': 'Bitte prüfen Sie den Text',
    'No text was written: it would need facts that no source holds.': 'Es wurde kein Text erstellt: Er bräuchte Fakten, die in keiner Quelle stehen.',
    'AI can get facts wrong. Read the text carefully before you publish it.': 'KI kann Fakten falsch wiedergeben. Lesen Sie den Text vor dem Veröffentlichen sorgfältig durch.',
    'The text was written without the knowledge base and may be incomplete.': 'Der Text wurde ohne die Wissensdatenbank erstellt und kann unvollständig sein.',
    'Search variable...': 'Variable suchen...',
    'No variables found': 'Keine Variablen gefunden',
    'Employee name': 'Name des Mitarbeiters',
    'Employee email': 'E-Mail des Mitarbeiters',
    'Point of sale / location': 'Kasse / Standort',
    'CMS name': 'CMS-Name',
    'Recipient name': 'Name des Empfängers',
    'Ticket number': 'Ticketnummer',
    'Ticket subject': 'Ticket-Betreff',
    // Stripe's reason codes for a rejected SEPA debit / a dispute, as the
    // billing history and the customer's invoice list show them.
    payment_reason: {
        insufficient_funds: 'Konto nicht gedeckt',
        account_closed: 'Konto geschlossen',
        bank_account_restricted: 'Lastschriften vom Konto gesperrt',
        debit_not_authorized: 'Lastschrift nicht autorisiert, Mandat fehlt',
        authorization_revoked: 'Mandat widerrufen',
        debit_disputed: 'Vom Kunden bei seiner Bank zurückgefordert',
        debit_authorization_not_match: 'Mandatsdaten stimmen nicht',
        invalid_account_number: 'IBAN ungültig',
        incorrect_account_holder_name: 'Kontoinhaber stimmt nicht',
        branch_does_not_exist: 'Bankfiliale existiert nicht',
        recipient_deceased: 'Kontoinhaber verstorben',
        refer_to_customer: 'Bank nennt keinen Grund, Kunden fragen',
        generic_could_not_process: 'Bank konnte nicht verarbeiten',
        processing_error: 'Verarbeitungsfehler',
        try_again_later: 'Später erneut versuchen',
        card_declined: 'Karte abgelehnt',
        expired_card: 'Karte abgelaufen',
        general: 'Ohne Angabe von Gründen',
        fraudulent: 'Als betrügerisch gemeldet',
        bank_cannot_process: 'Bank konnte nicht verarbeiten',
        customer_initiated: 'Vom Kunden veranlasst',
        lost: 'Endgültig verloren',
        won: 'Zu unseren Gunsten entschieden',
        lost_or_stolen_card: 'Karte gesperrt',
        expired_or_canceled_card: 'Karte abgelaufen oder gekündigt',
        unknown: 'Grund unbekannt',
        canceled: 'Abgebrochen',
        warning_closed: 'Anfrage ohne Rücklastschrift beendet',
        charge_refunded: 'Bereits erstattet',
        check_returned: 'Scheck zurückgegeben',
        credit_not_processed: 'Gutschrift nicht verbucht',
        duplicate: 'Doppelte Abbuchung',
        incorrect_account_details: 'Falsche Kontodaten',
        product_not_received: 'Leistung nicht erhalten',
        product_unacceptable: 'Leistung beanstandet',
        subscription_canceled: 'Abo gekündigt',
        unrecognized: 'Abbuchung nicht erkannt',
        charge_for_pending_refund_disputed: 'Zahlung während der Erstattung angefochten',
        declined: 'Von der Bank abgelehnt',
        merchant_request: 'Auf unsere Anfrage',
    },
    payment_event: {
        payment_failed: 'Lastschrift abgelehnt',
        payment_canceled: 'Zahlung abgebrochen',
        dispute_created: 'Rücklastschrift durch den Kunden',
        dispute_closed: 'Rücklastschrift abgeschlossen',
        dispute_funds_withdrawn: 'Betrag einbehalten',
        dispute_funds_reinstated: 'Betrag zurückerhalten',
        refunded: 'Erstattet',
        refund_failed: 'Erstattung fehlgeschlagen',
    },
    // A ticket's status, the ONE set of labels for every ticket surface
    // (TICKET_STATUS_KEYS in extensions/tickets/ticketStatus.js).
    ticket_status: {
        'new': 'Neu',
        'estimate-effort': 'Aufwand abschätzen',
        'in-progress': 'In Bearbeitung',
        'pending': 'Warten auf Feedback',
        'on-hold': 'Zurückgestellt',
        'completed': 'Abgeschlossen',
        'not-reproducible': 'Nicht reproduzierbar',
        'closed': 'Geschlossen',
    },
    invoice_status: {
        draft: 'Entwurf',
        pending: 'Zahlung ausstehend',
        paid: 'Bezahlt',
        failed: 'Zahlung fehlgeschlagen',
        cancelled: 'Storniert',
        disputed: 'Rücklastschrift',
        refunded: 'Erstattet',
    },

    // Discard guard for dialogs that hold unsaved work (src/mixins/discardGuard.js)
    'Discard changes?': 'Änderungen verwerfen?',
    'Your changes have not been saved.': 'Deine Änderungen sind nicht gespeichert.',
    Discard: 'Verwerfen',
    'Keep editing': 'Weiter bearbeiten',
};

export default de;
